module.exports = node-xmpp-client;